import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import LanguageSwitcher from '../common/LanguageSwitcher';

interface MobileNavProps {
  isOpen: boolean;
}

const MobileNav: React.FC<MobileNavProps> = ({ isOpen }) => {
  const { t } = useTranslatedContent('common');

  const links = [
    { href: '#home', label: t('nav.home') },
    { href: '#solutions', label: t('menu.solutions') },
    { href: '#services', label: t('nav.services') },
    { href: '#training', label: t('nav.training') },
    { href: '#cloud', label: t('nav.cloud') },
    { href: '#whatsnew', label: t('menu.news.title') },
    { href: '#vmware-migration', label: t('menu.news.vmware') },
    { href: '#contact', label: t('nav.contact') }
  ];

  if (!isOpen) return null;

  return (
    <div className="md:hidden bg-white border-t border-gray-100">
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="block px-3 py-2 text-gray-600 hover:text-blue-600 transition-colors duration-200"
            onClick={() => {
              const element = document.querySelector(link.href);
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            {link.label}
          </a>
        ))}
        <div className="px-3 py-2 border-t border-gray-100">
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
};

export default MobileNav;